import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/apps/id/general/page';

export const Route = createFileRoute('/_app/_chat/apps/$id/general/')({
  component: Page,
});
